var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('main',[_c('article',{staticClass:"row"},[_c('section',{staticClass:"col s12"},[_c('article',{staticClass:"row"},[_c('section',{staticClass:"col s4"}),_c('section',{staticClass:"col s4"},[_c('h4',{staticClass:"grey-text text-lighten-5"},[_c('strong',[_vm._v("Loading")])])]),_c('section',{staticClass:"col s4"})])])])])
}]

export { render, staticRenderFns }